function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useLocation } from "@custom/schema";
import React, { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { ParallaxProvider } from "react-scroll-parallax";
import { DomainProvider, useDomain } from "../../utils/domain";
import { LocalizationProvider } from "../../utils/localization";
import { PageTranslationsProvider } from "../../utils/page-translations";
export { initAppConfig } from "../../utils/app-config";
function DomainBodyClass(param) {
  var children = param.children;
  var domain = useDomain();
  useEffect(function () {
    if (domain.bodyClass) {
      var bodyElement = document.body;
      // Remove any existing theme- classes
      var existingClasses = Array.from(bodyElement.classList).filter(function (cls) {
        return cls.startsWith("theme-");
      });
      existingClasses.forEach(function (cls) {
        return bodyElement.classList.remove(cls);
      });
      // Add the new theme class
      bodyElement.classList.add("theme", domain.bodyClass);
      return function () {
        if (domain.bodyClass) {
          bodyElement.classList.remove("theme", domain.bodyClass);
        }
      };
    }
  }, [domain.bodyClass]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
function DefaultTheme(param) {
  var children = param.children;
  var domain = useDomain();
  var _useState = _sliced_to_array(useState(true), 2),
    defaultHtmlTheme = _useState[0],
    setDefaultHtmlTheme = _useState[1];
  useEffect(function () {
    if (domain.id !== "paraplegie_ch") {
      setDefaultHtmlTheme(false);
    } else {
      setDefaultHtmlTheme(true);
    }
    if (defaultHtmlTheme) {
      document.documentElement.classList.add("is-default-theme");
    } else {
      document.documentElement.classList.remove("is-default-theme");
    }
  }, [defaultHtmlTheme, domain.id]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
function ScrollToHash(param) {
  var children = param.children;
  var _useLocation = _sliced_to_array(useLocation(), 1),
    location = _useLocation[0];
  useEffect(function () {
    var anchorString = "";
    if (location.hash.charAt(0) == "#") {
      anchorString = location.hash.substring(1);
    }
    var scrollToHash = function scrollToHash() {
      if (location.hash.length) {
        setTimeout(function () {
          var _document_getElementById;
          (_document_getElementById = document.getElementById(anchorString)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.scrollIntoView({
            behavior: "smooth"
          });
        }, 100);
      }
    };
    window.addEventListener("load", scrollToHash);
    scrollToHash();
    return function () {
      return window.removeEventListener("load", scrollToHash);
    };
  }, [location.hash]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
export function Providers(param) {
  var domain = param.domain,
    locale = param.locale,
    children = param.children,
    path = param.path,
    localizations = param.localizations,
    i18n = param.i18n;
  return /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18n
  }, /*#__PURE__*/React.createElement(ParallaxProvider, null, /*#__PURE__*/React.createElement(PageTranslationsProvider, {
    path: path,
    language: locale,
    localizations: localizations
  }, /*#__PURE__*/React.createElement(ScrollToHash, null, /*#__PURE__*/React.createElement(LocalizationProvider, {
    defaultLocale: "de",
    locale: locale
  }, /*#__PURE__*/React.createElement(DomainProvider, {
    domain: domain
  }, /*#__PURE__*/React.createElement(DefaultTheme, null, /*#__PURE__*/React.createElement(DomainBodyClass, null, children))))))));
}